import { render, staticRenderFns } from "./HomePostCardTemplate.vue?vue&type=template&id=91dc3c96&scoped=true&"
import script from "./HomePostCardTemplate.vue?vue&type=script&lang=js&"
export * from "./HomePostCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./HomePostCardTemplate.vue?vue&type=style&index=0&id=91dc3c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dc3c96",
  null
  
)

export default component.exports